import { Currency, Invoice } from "../../types/InvoiceTypes";

export const useDisplayInvoiceWalletSection = (invoice?: Invoice) => {
  if (!invoice) {
    return false;
  }

  const { user_is_issuer, outgoing_currency } = invoice;

  return (
    user_is_issuer &&
    // USDC->INR can choose INR wallet, but usdc->eur can not choose EUR wallet
    //currency !== Currency.USDC &&
    outgoing_currency !== Currency.EUR
  );
};
